import { convert } from 'convert';

const isPositiveNumber = (input: unknown): input is number =>
  typeof input === 'number' && !isNaN(input) && input >= 0;

export function feetAndInchesToInches(
  feet: number | undefined,
  inches: number | undefined,
) {
  if (!isPositiveNumber(feet)) feet = 0;
  if (!isPositiveNumber(inches)) inches = 0;

  return Number(feet) * 12 + Number(inches);
}

export function inchesToFeetAndInches(inches: number | undefined) {
  if (isPositiveNumber(inches)) {
    if (inches < 12) return { feet: 0, inches };

    const feet = Math.floor(inches / 12);
    const retInches = Math.floor(inches % 12);

    return { feet, inches: retInches };
  } else {
    return { feet: 0, inches: 0 };
  }
}

export function centimetersToInches(centimeters: number) {
  return (
    Math.round(convert(centimeters, 'centimeters').to('inches') * 10e6) / 10e6
  );
}

export function inchesToCentimeters(inches: number) {
  return Math.round(convert(inches, 'inches').to('centimeters') * 10e6) / 10e6;
}

export function inchesToMillimeters(inches: number) {
  return Math.round(convert(inches, 'inches').to('millimeters') * 10e6) / 10e6;
}

export const feetAndInchesToCm = (feetAndInches: string) => {
  const [feet, inches] = feetAndInches.split('-');
  const totalInches = feetAndInchesToInches(parseInt(feet), parseInt(inches));
  return inchesToCentimeters(totalInches);
};

export const cmToFeetAndInches = (cm: number) => {
  const totalInches = Math.round(centimetersToInches(cm));

  const { feet, inches } = inchesToFeetAndInches(totalInches);
  return `${feet}${feet > 1 || inches > 0 ? `-${inches}` : ''}`;
};

export const cmToMeters = (cm: number) => {
  return (cm / 100).toFixed(2);
};

export const metersToCm = (cm: string) => {
  return parseFloat(cm) * 100;
};
